import React from "react";
import './footer.css';
import Logo from "./logo_amservices.png";
import { NavLink, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleSelectCity = (event) => {
    const path = event.target.value;
    if (path) {
      navigate(path);
    }
  };

  const cities = [
    { name: "Remiremont", path: "/infrastructure/remiremont" },
    { name: "Épinal", path: "/infrastructure/epinal" },
    { name: "Gérardmer", path: "/infrastructure/gerardmer" },
    { name: "Saint-Dié", path: "/infrastructure/saint-die" },
    { name: "Luxeuil-les-Bains", path: "/infrastructure/luxeuil" },
  ];

  return (
    <footer className="main-footer-component">
      <div className="footer-max-container">
        
        {/* COLONNE LOGO & ACCROCHE */}
        <div className="footer-brand-column">
          <NavLink to="/" className="footer-logo-link">
            <img src={Logo} className="footer-logo" alt="Logo AM Services" />
          </NavLink>
          <p className="footer-brand-desc">
            Infrastructures informatiques, télécoms de pointe et architectures de cybersécurité managées dans les Vosges.
          </p>
        </div>

        {/* COLONNE NAVIGATION & LIENS LEGAUX */}
        <div className="footer-links-column">
          <h4>Navigation</h4>
          <div className="footer-nav-links">
            <NavLink className="footer-link" to="/mentionlegal">
              Mentions Légales
            </NavLink>
            <a href="/admin/login.php" className="footer-link admin-lock-link">
              Espace Admin
            </a>
          </div>
        </div>

        {/* COLONNE ZONE GÉOGRAPHIQUE (UX + SEO) */}
        <div className="footer-geo-column">
          <h4>Nos zones d'intervention</h4>
          <div className="select-wrapper-cyber">
            <select onChange={handleSelectCity} className="select-zones-cyber">
              <option value="">Choisissez votre ville...</option>
              {cities.map((city, index) => (
                <option key={index} value={city.path}>{city.name}</option>
              ))}
            </select>
          </div>

          {/* INDEXATION PROPRE POUR GOOGLE (Accessible sans enfreindre les règles Google Search) */}
          <ul className="seo-hidden-links">
            {cities.map((city, index) => (
              <li key={index}>
                <NavLink to={city.path}>{city.name}</NavLink>
              </li>
            ))}
          </ul>
        </div>

      </div>

      {/* FOOTER DROITS BAS DE PAGE */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-container">
          <p>© 2026 AM Services. Tous droits réservés.</p>
          <p className="tech-signature">Infrastructures & Cybersécurité</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;